class MaterialTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.material-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.material-tabs__panel'));
    this.mediaItems = Array.from(this.querySelectorAll('.material-tabs__media-item'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.panel));
    });

    // Videos are preload="none" with no autoplay attribute, so nothing downloads
    // until the section scrolls into view; then only the active tab's video plays.
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = this.querySelector('.material-tabs__media-item.is-active video');
            if (!video) return;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { rootMargin: '200px 0px' }
      );
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  activate(panelId) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.panel === panelId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.panel === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    this.mediaItems.forEach((item) => {
      const isActive = item.dataset.panel === panelId;
      item.classList.toggle('is-active', isActive);

      const video = item.querySelector('video');
      if (!video) return;

      if (isActive) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  }
}

if (!customElements.get('material-tabs')) {
  customElements.define('material-tabs', MaterialTabs);
}
